import { IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { isLeadFactory } from './agent';

export function getMainContactsDescription(offer: IOfferSchema) {
  if (isLeadFactory(offer)) {
    return 'Задайте интересующие вас вопросы консультантам Циан.';
  }

  return 'Наиболее свежая информация находится у владельца объявления.';
}
